<template>
  <a
    v-if="isLink"
    :href="href"
    :target="target"
    @click="$emit('click')"
  >
    <img
      :src="`/svg/${pathToImg}/${icon}.svg`"
      :alt="icon"
    >
  </a>

  <img
    v-else
    class="icon"
    :clickable="clickable"
    :src="`/svg/${pathToImg}/${icon}.svg`"
    :alt="icon"
    @click="$emit('click')"
  >
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    isLink: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: "#"
    },
    target: {
      type: String,
      default: "_self"
    },
    clickable: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ""
    }
  },

  emits: ["click"],

  computed: {
    theme() {
      return this.$store.getters.isLightTheme ? "light" : "dark";
    },

    pathToImg() {
      return this.path ? this.path : this.theme;
    }
  }
};
</script>

<style scoped lang="scss">
a.btn {
  &:active{
    border-color: transparent;
  }
}
img {
  max-width: inherit;

  &[as-button] {
    padding: 10px;
    &:hover {
      cursor: pointer;
    }
  }
}

.icon[clickable=true] {
  padding: 10px;
    &:hover {
      cursor: pointer;
    }
}

.icon {
  min-height: 16px;
  min-width: 16px;
}
</style>
